import React from 'react';
import PropTypes from 'prop-types';
import { IoClose } from 'react-icons/io5';

import Modal from 'react-modal';
import { styledTheme } from 'globalStyles/theme';
import './styles.scss';

const ErrorModal = ({ open, onClose, children }) => {
  return (
    <Modal
      ariaHideApp={false}
      isOpen={open}
      contentLabel="PodoModal"
      className="invoice-modal__error"
      shouldCloseOnOverlayClick
      onRequestClose={onClose}
      style={{
        overlay: {
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          padding: 0,
          backgroundColor: styledTheme.modalBackground,
        },
      }}
    >
      <div
        className="invoice-modal__header"
        onClick={onClose}
      >
        <IoClose
          className="invoice-modal__close"
          size={20}
          onClick={onClose}
        />
      </div>
      <div className="invoice-modal__body invoice-modal__body--error">
        {children}
      </div>
    </Modal>
  );
};

ErrorModal.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
};

ErrorModal.defaultProps = {
  open: true,
  onClose: () => {},
};

export default ErrorModal;
